import axios from "axios";

// const API_BASE_URL = "http://127.0.0.1:3002/api/v1";
// const API_BASE_URL = "https://backend-vmpgns.vercel.app/api/v1";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axios_instance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 120000, // ⏱️ Set timeout to 120 seconds
  maxContentLength: 100 * 1024 * 1024, // 100MB
  maxBodyLength: 100 * 1024 * 1024, // 100MB
});

axios_instance.defaults.headers.common["Content-Type"] = "application/json";

// Add an interceptor to include Authorization token in all requests
axios_instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Retrieve token from local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Attach token to every request
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios_instance;
